if (window.innerWidth <= 991) {
  document.addEventListener("DOMContentLoaded", function () {
    const mainImage = document.getElementById("mainImage");
    const zoomModal = document.getElementById("zoomModal");
    const zoomImage = document.getElementById("zoomImage");
    let startX = 0;
    let startY = 0;
    mainImage.addEventListener("touchstart", function (event) {
      event.preventDefault(); // Previne o comportamento padrão do toque (scroll, zoom, etc.)
      const rect = mainImage.getBoundingClientRect();
      startX = event.touches[0].clientX - rect.left;
      startY = event.touches[0].clientY - rect.top;
      const modalSize = 100;
      // Posiciona o modal no centro do toque
      zoomModal.style.width = modalSize + "px";
      zoomModal.style.height = modalSize + "px";
      zoomModal.style.left = event.touches[0].pageX - modalSize / 2 + "px";
      zoomModal.style.top = event.touches[0].pageY - modalSize / 2 + "px";
      zoomModal.style.display = "block";
      const scaleFactor = 2; // Fator de escala do zoom
      const imageX = startX * scaleFactor - modalSize / 2;
      const imageY = startY * scaleFactor - modalSize / 2;
      zoomImage.style.left = -imageX + "px";
      zoomImage.style.top = -imageY + "px";
    });
    document.addEventListener("click", function (event) {
      if (
        !mainImage.contains(event.target) &&
        !zoomModal.contains(event.target)
      ) {
        zoomModal.style.display = "none";
      }
    });
  });
} else {
  document.addEventListener("DOMContentLoaded", function () {
    const mainImage = document.getElementById("mainImage");
    const zoomModal = document.getElementById("zoomModal");
    const zoomImage = document.getElementById("zoomImage");
    mainImage.addEventListener("click", function (event) {
      const rect = mainImage.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const modalSize = 100;
      zoomModal.style.width = modalSize + "px";
      zoomModal.style.height = modalSize + "px";
      zoomModal.style.left = event.pageX - modalSize / 2 + "px";
      zoomModal.style.top = event.pageY - modalSize / 2 + "px";
      zoomModal.style.display = "block";
      const scaleFactor = 2;
      const imageX = x * scaleFactor - modalSize / 2;
      const imageY = y * scaleFactor - modalSize / 2;
      zoomImage.style.left = -imageX + "px";
      zoomImage.style.top = -imageY + "px";
    });
    document.addEventListener("click", function (event) {
      if (
        !mainImage.contains(event.target) &&
        !zoomModal.contains(event.target)
      ) {
        zoomModal.style.display = "none";
      }
    });
  });
}
